<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin: 0 0 0 20px"
        separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/insPoint'}">巡检管理</el-breadcrumb-item>
        <el-breadcrumb-item>巡检点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content">
      <el-form :model="form"
        :rules="rules"
        label-width="200px"
        class="demo-ruleForm"
        style="width:60%;marginLeft: 15%">
        <el-form-item label="编号"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-input v-model="form.number" size="small"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="名称"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-input v-model="form.name" size="small"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="巡检模式"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-radio-group v-model="form.checkType" size="small">
              <el-radio-button label="0">扫码</el-radio-button>
              <el-radio-button label="1">NFC</el-radio-button>
              <el-radio-button label="2">普通</el-radio-button>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="区域"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-select v-model="form.areaId" filterable placeholder="请选择" size="small">
              <el-option v-for="item in areas" :key="item.id" :label="item.cellName" :value="item.id" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="是否关联设备"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-radio-group v-model="checkEquipment" size="small" @change="checkEquipmentChange">
              <el-radio-button :label="0">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
            <el-select v-if="checkEquipment === 1" v-model="form.equipment_id" multiple
             placeholder="请选择" size="small" style="width: calc(100% - 100px); marginLeft: 10px">
              <el-option v-for="item in EquimentSelect" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="是否关联风险点"
          style="margin-bottom: 20px;"
          prop="region">
          <div class="block">
            <el-radio-group v-model="checkRiskPoint" size="small" @change="checkRiskPointChange">
              <el-radio-button :label="0">否</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
            </el-radio-group>
            <el-select v-if="checkRiskPoint === 1" v-model="form.riskPointIds" multiple
             placeholder="请选择" size="small" style="width: calc(100% - 100px); marginLeft: 10px">
              <el-option v-for="item in riskPointList" :key="item.id" :label="item.riskName" :value="item.id" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="巡检项目"
          prop="list">
          <div v-if="!isShowBtn" v-for="(item,index) in emergeData" :key="index" style="margin-top: 1%">
            <el-input size="small" v-model="item.name" style="width:60%;" placeholder="请输入名称" />
            <el-select size="small" v-model="item.input" multiple filterable allow-create
             placeholder="请选择" style="width: 30%;margin-left: 10px">
              <el-option v-for="item in inputOption" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-button size="small"
              type="danger"
              icon="el-icon-delete"
              style="margin-left:20px"
              @click="handDelEme(index)"
              circle></el-button>
          </div>
          <el-button size="small"
            style="width:100%;margin-top: 5px"
            @click="handleAddEme()"
            type="info">添加</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button size="small" type="primary" class="addBtn" @click="submitForm()">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getTypeList, getRiskPointList } from '@/api/processManager'
export default {
  data() {
    return {
      areas: '',
      isAdd: true,
      form: {
        checkType: '1'
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      options: [],
      getObj: {},
      isShowBtn: true,
      isShowBtn2: true,
      checkOptions: [],
      emergeData: [],
      fileList: [],
      inputOption: [
        {
          id: '抄表值',
          name: '抄表值'
        },
        {
          id: '备注',
          name: '备注'
        }
      ],
      checkEquipment: 0, // 是否关联设备
      EquimentSelect: [], // 设备下拉框
      checkRiskPoint: 0, // 是否关联巡检点
      riskPointList: [], // 风险点的数据
    }
  },
  created() {
    let obj = this.$route.params.key
    if (this.$route.params.key) {
      this.isAdd = false
      this.form = obj
      let options = JSON.parse(obj.checkOptions)
      for (let j = 0; j < options.length; j++) {
        let name = options[j].name
        let input = options[j].input
        this.emergeData.push({
          name: name,
          input: input
        })
      }
      this.handleAddEme()
      let length = this.emergeData.length
      this.emergeData.splice(length - 1, 1)
      // console.log(obj)
      // console.log(obj.equipment_id)
      if (obj.equipment_id !== '' && obj.equipment_id !== null && obj.equipment_id !== 'null') {
        let arr = obj.equipment_id.split(',')
        let newArr = []
        for(let m in arr) {
          newArr.push(Number(arr[m]))
        }
        this.form.equipment_id = newArr
        this.checkEquipment = 1
      } else {
        this.form.equipment_id = [] 
      }
      if (obj.riskPointIds !== '' && obj.riskPointIds !== 'null' && obj.riskPointIds !== null) {
        let arr2 = obj.riskPointIds.split(',')
        let newArr2 = []
        for(let k in arr2) {
          newArr2.push(Number(arr2[k]))
        }
        this.form.riskPointIds = newArr2
        this.checkRiskPoint = 1
      } else {
        this.riskPointIds = [] 
      }
    } else {
      this.form = {
        equipment_id: []
      }
    }
  },
  mounted() {
    this.getAllArea();
    this.getRiskPoint();
    getTypeList().then(res => {
      this.EquimentSelect = res.body.data
    })
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    handDelEme(index) {
      // console.log(index);
      this.emergeData.splice(index, 1)
    },
    handleAddEme() {
      this.isShowBtn = false
      this.emergeData.push({
        serialNumber: '',
        situation: '',
        dialogVisible: false,
        dealMethod: '',
        type: 1
      })
    },

    // 获取风险点
    getRiskPoint() {
      getRiskPointList({ limit: 1000, curPage: 1 }).then(res => {
        this.riskPointList = res.body.data
      })
    },

    getAllArea() {
      let url = '/dangerinfo/list_all?limit=' + 500 + '&curPage=' + 1
      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startGet()
        .then(res => {
          this.areas = res.body.data
        })
    },

    submitForm() {
      let url = ''
      if (this.isAdd) {
        url = '/inspectioncheckpoint/save'
      } else {
        url = '/inspectioncheckpoint/update'
      }
      let arr = []
      for (var i = 0; i < this.emergeData.length; i++) {
        arr.push({
          name: this.emergeData[i].name,
          input: this.emergeData[i].input
        })
      }
      let obj = { ...this.form }
      obj.checkOptions = JSON.stringify(arr)
      if(this.checkEquipment === 1 && this.form.equipment_id.length > 0) {
        obj.equipment_id = this.form.equipment_id.join(',')
      } else {
        obj.equipment_id = ''
      }
      if(this.checkRiskPoint === 1 && this.form.riskPointIds.length > 0) {
        obj.riskPointIds = this.form.riskPointIds.join(',')
      } else {
        obj.riskPointIds = ''
      }
      this.componentsMoudel.httpRequest
        .getRequestHander(url)
        .openLoad()
        .startPost(obj)
        .then(res => {
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          })

          this.$router.push({
            path: '/processManager/insPoint'
          })
        })
    },

    // 点击不绑定设备的时候 把设备的值清掉
    checkEquipmentChange(val) {
      if (val === 0) {
        this.form.equipment_id = []
      }
    },
    checkRiskPointChange(val) {
      if (val === 0) {
        this.form.riskPointIds = []
      }
    }
  }
}
</script>

<style scoped>
.addBtn {
  width: 100%;
}

.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 160px;
}

.el-divider__text {
  font-size: 20px !important;
}
</style>
